<app-page-title [title]="'View Registered Tests'"></app-page-title>
<br />
<div
    class="row"
    *ngIf="childAccountRegs && childAccountRegs.length > 0"
>
    <div class="col-md-12">
        <h4>Test registrations</h4>

        <div
            id="filterPanel"
            class="panel panel-default"
        >
            <label class="filter-label">Filter by:</label>
            <div class="panel-body row">
                <div class="form-group col-md-2">
                    <label class="control-label">Registration Number</label>
                    <input
                        class="form-control"
                        name="regNumber"
                        [(ngModel)]="regNumber"
                        placeholder="Click to enter"
                        (ngModelChange)="getFilteredRegistrations()"
                    />
                </div>
                <div class="form-group col-md-2">
                    <label class="control-label">Name</label>
                    <input
                        class="form-control"
                        name="partialName"
                        [(ngModel)]="partialName"
                        placeholder="Click to enter"
                        (ngModelChange)="getFilteredRegistrations()"
                    />
                </div>
                <div class="form-group col-md">
                    <label class="control-label">Test Date from</label>
                    <input
                        type="date"
                        class="form-control"
                        name="startFilterDate"
                        min="{{minDate | date:'yyyy-MM-dd'}}"
                        max="{{yearFromTodayDate | date:'yyyy-MM-dd'}}"
                        [(ngModel)]="startFilterDate"
                        placeholder="Click to select"
                        (change)="getFilteredRegistrations()"
                    />
                </div>
                <div class="form-group col-md">
                    <label class="control-label">Test Date To</label>
                    <input
                        type="date"
                        class="form-control"
                        name="endFilterDate"
                        min="{{minDate | date:'yyyy-MM-dd'}}"
                        max="{{yearFromTodayDate | date:'yyyy-MM-dd'}}"
                        [(ngModel)]="endFilterDate"
                        placeholder="Click to select"
                        (change)="getFilteredRegistrations()"
                    />
                </div>
                <br />
                <div class="col-md-2">
                    <label class="control-label">Registration Status</label>
                    <select
                        [(ngModel)]="selectedRegStatus"
                        class="form-control"
                        name="selectedRegStatus"
                        (change)="getFilteredRegistrations()"
                    >
                        <option *ngFor="let regStatus of regStatusList">{{regStatus}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <table class="table">
                <thead>
                    <tr>
                        <th class="text-center table-column">Registration #</th>
                        <th class="text-center table-column">Test Date & Location</th>
                        <th class="text-center table-column">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="filteredChildAccountRegs.length == 0 || filteredChildAccountRegs == null || filteredChildAccountRegs == undefined ">
                        <td
                            class="text-center"
                            colspan="3"
                        >
                            There are no matching records</td>
                    </tr>
                    <tr *ngFor="let reg of filteredChildAccountRegs">
                        <td class="text-center">
                            <div><strong>{{reg.testTakerFullName}}</strong></div>
                            <div>{{reg.regId}} ({{reg.testTypeName}})</div>
                            <small>Registered on {{reg.registrationDate | date: "MMM dd, yyyy" }}</small>
                        </td>
                        <td class="text-center">
                            {{reg.testDateTime | customDate: 'formatDateTime'}} <small *ngIf="reg.isWebDelivery">(Time Zone: {{localTimeZone}})</small>
                            <small>{{reg.testCentreName}}</small>
                            <small
                                *ngIf="!reg.isWebDelivery"
                                class="white-space-pre"
                            >{{reg.testCentreLocation}}</small>
                            <div *ngIf="reg.canTransferBeforeTest">
                                <hr />
                                <a [routerLink]="['/account/transfer-registration',reg.regId]">Transfer to a different sitting</a>
                            </div>
                        </td>
                        <td class="text-center">
                            {{reg.regStatusName}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
